import React from "react"
import { Stack } from "@chakra-ui/react"
import UpgradeAlert from "components/elements/UpgradeAlert"
import useFeatureFlag from "services/featureFlags"
import QRCodeSecurity from "./QRCodeSecurity"
import RelatedSettings from "./RelatedSettings"
import AdditionalDocumentation from "./AdditionalDocumentation"
import QRCodesLegacy from "./QRCodesLegacy"

type Props = {
  qrCodesEnabled: boolean
  temporalQRCodesEnabled: boolean
  expiringQRCodes: boolean
  eventId: string
  updateEvent: (params: {}) => Promise<void>
}

const QRCodes = ({
  qrCodesEnabled, temporalQRCodesEnabled, expiringQRCodes, eventId, updateEvent,
}: Props) => {
  const { temporalQrCodes: temporalQRCodesFeatureFlagEnabled } = useFeatureFlag()

  if (!temporalQRCodesFeatureFlagEnabled) {
    return <QRCodesLegacy qrCodesEnabled={qrCodesEnabled} />
  }

  return (
    <Stack spacing={12}>
      <QRCodeSecurity
        expiringQRCodes={expiringQRCodes}
        updateEvent={updateEvent}
        qrCodesEnabled={qrCodesEnabled}
        temporalQRCodesEnabled={temporalQRCodesEnabled}
      />
      <RelatedSettings eventId={eventId} />
      <AdditionalDocumentation />
      {!qrCodesEnabled && (<UpgradeAlert text="QR code distribution and scanning are available with a Professional Subscription or higher." />)}
    </Stack>
  )
}

export default QRCodes
